(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function getSections(scope) {
      const sections = [];
      if (scope instanceof Element && scope.classList && scope.classList.contains('rauhia-collections')) {
        sections.push(scope);
      }
      if (scope.querySelectorAll) {
        scope.querySelectorAll('.rauhia-collections').forEach((el) => {
          if (!sections.includes(el)) sections.push(el);
        });
      }
      return sections;
    }

    function initRauhiaCollections(scope = document) {
      const sections = getSections(scope);
      if (!sections.length) return;

      sections.forEach((section) => {
        if (section.dataset.rauhiaCollectionsInit === 'true') return;
        section.dataset.rauhiaCollectionsInit = 'true';

        const tabsWrap = section.querySelector('[data-rauhia-tabs]');
        const tabs = Array.from(section.querySelectorAll('[data-rauhia-tab]'));
        const cards = Array.from(section.querySelectorAll('[data-rauhia-card]'));
        const prevBtn = section.querySelector('[data-rauhia-prev]');
        const nextBtn = section.querySelector('[data-rauhia-next]');
        const mobileQuery = window.matchMedia('(max-width: 989px)');
        const visibleCount = 3;

        if (!tabsWrap || !tabs.length || !cards.length) return;

        let activeIndex = 0;

        function updateButtons() {
          if (prevBtn) prevBtn.disabled = activeIndex === 0;
          if (nextBtn) nextBtn.disabled = activeIndex === tabs.length - 1;
        }

        function updateTabs(scrollActiveTab = true) {
          tabs.forEach((tab, index) => {
            tab.classList.toggle('is-active', index === activeIndex);
          });

          if (scrollActiveTab && tabs[activeIndex]) {
            tabs[activeIndex].scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
        }

        function updateCards() {
          if (!mobileQuery.matches) {
            cards.forEach((card) => {
              card.classList.remove('is-mobile-visible');
              card.style.display = '';
              card.style.order = '';
            });
            return;
          }

          cards.forEach((card, index) => {
            const relativeIndex = (index - activeIndex + cards.length) % cards.length;
            const shouldShow = relativeIndex < visibleCount;

            card.classList.toggle('is-mobile-visible', shouldShow);
            card.style.display = shouldShow ? 'block' : 'none';
            card.style.order = shouldShow ? String(relativeIndex) : '999';
          });
        }

        function setActive(index, scrollActiveTab = true) {
          const safeIndex = Math.max(0, Math.min(index, tabs.length - 1));
          activeIndex = safeIndex;
          updateTabs(scrollActiveTab);
          updateButtons();
          updateCards();
        }

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            setActive(index, true);
          });
        });

        if (prevBtn) {
          prevBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (activeIndex > 0) setActive(activeIndex - 1, true);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (activeIndex < tabs.length - 1) setActive(activeIndex + 1, true);
          });
        }

        const handleViewportChange = () => {
          setActive(activeIndex, false);
        };

        if (mobileQuery.addEventListener) {
          mobileQuery.addEventListener('change', handleViewportChange);
        } else if (mobileQuery.addListener) {
          mobileQuery.addListener(handleViewportChange);
        }

        setActive(0, false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initRauhiaCollections(document));
    } else {
      initRauhiaCollections(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initRauhiaCollections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
